<template>
  <!-- 经济发展 指标卡 -->
  <div class="NEWeconomics" v-if="NEWeconomicsDisplay">
    <!-- 自贸区进出口总额 -->
    <div class="item item1" v-if="tmxList.length > 0 && tmxList[0].val">
      <div class="title">
        <span>FTZ Import&Export</span>
      </div>
      <div class="money">
        <span
          >{{ tmxList.length > 0 ? tmxList[0].val : "" }}
          <span v-show="tmxList.length > 0">billion CNY</span>
          <span v-show="tmxList.length === 0"
            >The data has not been released yet</span
          >
        </span>
        <img
          src="../../../assets/images/fta/ftaInfoTap/Zmqsl.svg"
          style="height: 48px"
        />
      </div>
      <div class="area">
        <span>{{ info.ftzName }}</span>
        <span
          >{{ tmxList.length > 0 ? tmxList[0].name : "" }}
          <span v-show="tmxList.length > 0"></span>
        </span>
        <span
          v-show="tmxList.length > 0"
          class="more"
          @click="
            NEWeconomics(
              1,
              NEWeconomicsTbaleDisplay1,
              tmxList.length > 0 ? tmxList : []
            )
          "
          >more>></span
        >
      </div>
    </div>
    <!-- 自贸区吸引外资投资总额 -->
    <div class="item item2" v-if="fgnInvestList.length && fgnInvestList[0].val">
      <div class="title">
        <span>FTZ FDI</span>
      </div>
      <div class="money">
        <span
          >{{ fgnInvestList.length > 0 ? fgnInvestList[0].val : "" }}
          <span v-show="fgnInvestList.length > 0">billion USD</span>
          <span v-show="fgnInvestList.length === 0"
            >The data has not been released yet</span
          >
        </span>
        <img
          src="../../../assets/images/fta/ftaInfoTap/Xywztzze.svg"
          style="height: 47px"
        />
      </div>
      <div class="area">
        <span>{{ info.ftzName }}</span>
        <span
          >{{ fgnInvestList.length > 0 ? fgnInvestList[0].name : "" }}
          <span v-show="fgnInvestList.length > 0"></span>
        </span>
        <span
          v-show="fgnInvestList.length > 0"
          class="more"
          @click="
            NEWeconomics(
              2,
              NEWeconomicsTbaleDisplay2,
              fgnInvestList.length > 0 ? fgnInvestList : []
            )
          "
          >more>></span
        >
      </div>
    </div>
    <!-- 自贸区新增外资企业 -->
    <div
      class="item item3"
      v-if="newEntCountList.length && newEntCountList[0].val"
    >
      <div class="title">
        <span>FTZ New Foreign Company</span>
      </div>
      <div class="money">
        <span
          >{{ newEntCountList.length > 0 ? newEntCountList[0].val : "" }}
          <span v-show="newEntCountList.length > 0"></span>
          <span v-show="newEntCountList.length === 0"
            >The data has not been released yet</span
          >
        </span>
        <img
          src="../../../assets/images/fta/ftaInfoTap/Xzqy.svg"
          style="height: 48px"
        />
      </div>
      <div class="area">
        <span>{{ info.ftzName }}</span>
        <span
          >{{ newEntCountList.length > 0 ? newEntCountList[0].name : "" }}
          <span v-show="newEntCountList.length > 0"></span>
        </span>
        <span
          v-show="newEntCountList.length > 0"
          class="more"
          @click="
            NEWeconomics(
              3,
              NEWeconomicsTbaleDisplay3,
              newEntCountList.length > 0 ? newEntCountList : []
            )
          "
          >more>></span
        >
      </div>
    </div>
    <!-- 自贸区税收 -->
    <div class="item item4" v-if="taxList.length && taxList[0].val">
      <div class="title">
        <span>FTZ Tax Revenue</span>
      </div>
      <div class="money">
        <span
          >{{ taxList.length > 0 ? taxList[0].val : "" }}
          <span v-show="taxList.length > 0">billion CNY</span>
          <span v-show="taxList.length === 0"
            >The data has not been released yet</span
          >
        </span>
        <img
          src="../../../assets/images/fta/ftaInfoTap/003.svg"
          style="height: 48px"
        />
      </div>
      <div class="area">
        <span>{{ info.ftzName }}</span>
        <span
          >{{ taxList.length > 0 ? taxList[0].name : "" }}
          <span v-show="taxList.length > 0"></span>
        </span>
        <span
          v-show="taxList.length > 0"
          class="more"
          @click="
            NEWeconomics(
              4,
              NEWeconomicsTbaleDisplay4,
              taxList.length > 0 ? taxList : []
            )
          "
          >more>></span
        >
      </div>
    </div>
  </div>
  <!-- 经济发展 指标卡 对应表格 -->
  <div class="NEWeconomicsTable" v-else>
    <!-- 自贸区进出口总额 -->
    <div class="economicsTable" v-if="NEWeconomicsIndex === 1">
      <div class="title">
        <div class="left">
          <span style="float: right"
            >Growth Trend of Import and Export of FTZ
            <span
              class="economicsTable-download"
              style="float: right; margin-left: 10px"
            >
              <i
                class="el-icon-download"
                @click="
                  downLoadExcelzb(
                    `Growth Trend of Import and Export of ${info.ftzName}.xlsx`
                  )
                "
              ></i>
            </span>
          </span>
        </div>
        <div class="right">
          <span class="close" @click="closeNEWeconomicsTable()">
            <img src="../../../assets/images/fta/ftaInfoTap/Close.svg" />
            Close
          </span>
        </div>
      </div>
      <div class="table1">
        <FtaTable
          height="200"
          :sortable="true"
          :tableData="tmxList.length > 0 ? tmxList : []"
          :column="NEWeconomicsTbaleDisplay1"
          :diaLogShow="false"
          :isIndex="false"
        />
      </div>
    </div>
    <!-- 自贸区吸引外资投资总额 -->
    <div class="economicsTable" v-if="NEWeconomicsIndex === 2">
      <div class="title">
        <div class="left">
          <span style="float: right"
            >New foreign companies growth trend of FTZ
            <span
              class="economicsTable-download"
              style="float: right; margin-left: 10px"
            >
              <i
                class="el-icon-download"
                @click="
                  downLoadExcelzb(
                    `New foreign companies growth trend of ${info.ftzName}.xlsx`
                  )
                "
              ></i>
            </span>
          </span>
        </div>
        <div class="right">
          <span class="close" @click="closeNEWeconomicsTable()">
            <img src="../../../assets/images/fta/ftaInfoTap/Close.svg" />
            Close
          </span>
        </div>
      </div>
      <div class="table1">
        <FtaTable
          height="200"
          :sortable="true"
          :tableData="fgnInvestList.length > 0 ? fgnInvestList : []"
          :column="NEWeconomicsTbaleDisplay2"
          :diaLogShow="false"
          :isIndex="false"
        />
      </div>
    </div>
    <!-- 自贸区新增外资企业 -->
    <div class="economicsTable" v-if="NEWeconomicsIndex === 3">
      <div class="title">
        <div class="left">
          <span style="float: right"
            >FTZ Tax Revenue
            <span
              class="economicsTable-download"
              style="float: right; margin-left: 10px"
            >
              <i
                class="el-icon-download"
                @click="
                  downLoadExcelzb(`FDI Growth Trend of ${info.ftzName}.xlsx`)
                "
              ></i>
            </span>
          </span>
        </div>
        <div class="right">
          <span class="close" @click="closeNEWeconomicsTable()">
            <img src="../../../assets/images/fta/ftaInfoTap/Close.svg" />
            Close
          </span>
        </div>
      </div>
      <div class="table1">
        <FtaTable
          height="200"
          :sortable="true"
          :tableData="newEntCountList.length > 0 ? newEntCountList : []"
          :column="NEWeconomicsTbaleDisplay3"
          :diaLogShow="false"
          :isIndex="false"
        />
      </div>
    </div>
    <!-- 自贸区税收 -->
    <div class="economicsTable" v-if="NEWeconomicsIndex === 4">
      <div class="title">
        <div class="left">
          <span style="float: right"
            >Tax revenue growth trend of FTZ
            <span
              class="economicsTable-download"
              style="float: right; margin-left: 10px"
            >
              <i
                class="el-icon-download"
                @click="
                  downLoadExcelzb(
                    `Tax revenue growth trend of ${info.ftzName}.xlsx`
                  )
                "
              ></i>
            </span>
          </span>
        </div>
        <div class="right">
          <span class="close" @click="closeNEWeconomicsTable()">
            <img src="../../../assets/images/fta/ftaInfoTap/Close.svg" />
            Close
          </span>
        </div>
      </div>
      <div class="table1">
        <FtaTable
          height="200"
          :sortable="true"
          :tableData="taxList.length > 0 ? taxList : []"
          :column="NEWeconomicsTbaleDisplay4"
          :diaLogShow="false"
          :isIndex="false"
        />
      </div>
    </div>
  </div>
</template>

<script>
import request from "../../../ftaUtils/http";
import baseUrl from "../../../ftaUtils/baseUrl";
import FtaTable from "../component/FtaTable";
export default {
  components: {
    FtaTable,
  },
  props: {
    NEWeconomicsDisplay: {
      type: Boolean,
      default: true,
    },
    info: {
      type: Object,
      default() {
        return {};
      },
    },
    // 自贸区新增企业增长趋势
    newEntCountList: {
      type: Array,
      default() {
        return [];
      },
    },
    // 自贸区吸引外资投资总额增长趋势
    fgnInvestList: {
      type: Array,
      default() {
        return [];
      },
    },
    // 自贸区进出口总额增长趋势
    tmxList: {
      type: Array,
      default() {
        return [];
      },
    },
    taxList: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      pageConfig: {
        total: 10,
        page: 1,
        pageSize: 4,
      },
      // NEWeconomicsDisplay: true,
      NEWeconomicsIndex: 1,
      NEWeconomicsTbaleDisplay1: [
        { prop: "name", label: "Year" },
        {
          prop: "val",
          label: "Growth Trend of Import and Export of FTZ (billion CNY)",
        },
      ],
      NEWeconomicsTbaleExcel1: {
        fields: {},
        data: [],
      },
      NEWeconomicsTbaleDisplay2: [
        { prop: "name", label: "Year" },
        {
          prop: "val",
          label: "New foreign companies growth trend of FTZ (billion USD)",
        },
      ],
      NEWeconomicsTbaleDisplay3: [
        { prop: "name", label: "Year" },
        { prop: "val", label: "FTZ Tax Revenue" },
      ],
      NEWeconomicsTbaleDisplay4: [
        { prop: "name", label: "Year" },
        { prop: "val", label: "Tax revenue growth trend of FTZ (billion CNY)" },
      ],
    };
  },
  methods: {
    downLoadExcelzb(name) {
      console.log("下载文件");
      let json = {};
      json["fields"] = this.NEWeconomicsTbaleExcel1.fields;
      json["data"] = this.NEWeconomicsTbaleExcel1.data;
      // const fd = new FormData();
      // fd.append("dataJsonStr", JSON.stringify(json));
      console.log(encodeURI(JSON.stringify(json).trim()));
      request("post", `${baseUrl.base_1}/ftaInfo/download`, {
        dataJsonStr: JSON.stringify(json).trim(),
      }).then((res) => {
        let blob = new Blob([res.data], { type: "application/vnd.ms-excel" });
        let url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = name; // 重命名文件
        link.download.trim();
        link.click();
        window.URL.revokeObjectURL(url); // 释放内存
        // this.fullscreenLoading = false;
        loading.close();
      });
    },
    downloadExcel(fields, data) {
      console.log("downloadExcel-fields", fields);
      console.log("downloadExcel-data", data);
      const excelFields = {};
      for (let item of fields) {
        excelFields[item.label] = item.prop;
      }
      this.NEWeconomicsTbaleExcel1.fields = excelFields;
      this.NEWeconomicsTbaleExcel1.data = data;
    },
    NEWeconomics(item, fields, data) {
      this.NEWeconomicsIndex = item;
      this.$emit("changeNewecomic", false);
      const excelFields = {};
      for (let item of fields) {
        excelFields[item.label] = item.prop;
      }
      this.NEWeconomicsTbaleExcel1.fields = excelFields;
      this.NEWeconomicsTbaleExcel1.data = data;
    },
    closeNEWeconomicsTable() {
      this.$emit("changeNewecomic", true);
    },
  },
};
</script>

<style lang="less" scoped>
// 新修改
.NEWeconomics {
  border-top: 1px solid rgba(0, 0, 0, 0.2);
  padding-left: 40px;
  padding-right: 40px;
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  // height: 200px;
  justify-content: space-around;
  // background-color: rebeccapurple;
  .item {
    padding-top: 15px;
    padding-left: 20px;
    padding-right: 20px;
    padding-bottom: 10px;
    // flex-grow: 1;
    width: 25%;
    margin: 10px 10px;
    height: 130px;
    background-color: rgba(0, 9, 231, 0.4);
    display: flex;
    flex-direction: column;
    .title {
      span {
        font-weight: 500;
        color: #f5f5f5;
        font-size: 13px;
      }
    }
    .money {
      margin-left: 5px;
      display: flex;
      align-items: center;
      flex-direction: row;
      justify-content: space-between;
      flex-grow: 1;
      // background-color: rebeccapurple;
      span {
        color: #fff;
        font-size: 17px;
      }
    }
    .area {
      display: flex;
      justify-content: space-between;
      span {
        // width: 55%;
        color: #f5f5f5;
        font-size: 14px;
      }
      .more {
        text-align: right;
        cursor: pointer;
      }
      .more:hover {
        text-decoration: underline;
      }
    }
  }
  .item1 {
    background: rgba(32, 142, 255, 0.02);
    background-image: linear-gradient(
      90deg,
      #42bfe9 0%,
      #44aced 22%,
      #4b68fd 100%
    );
    border-radius: 4px;
  }
  .item2 {
    background-image: linear-gradient(
      90deg,
      #ee57dc 0%,
      #885af2 53%,
      #615bfa 100%
    );
    border: 2px solid #208eff;
    border-radius: 4px;
  }
  .item3 {
    background: rgba(32, 142, 255, 0.02);
    background-image: linear-gradient(90deg, #fca051 0%, #ff524e 100%);
    border-radius: 4px;
  }
  .item4 {
    background: rgba(32, 142, 255, 0.02);
    background-image: linear-gradient(
      90deg,
      #42bfe9 0%,
      #44aced 22%,
      #4b68fd 100%
    );
    border-radius: 4px;
  }
}

.NEWeconomicsTable {
  color: #000 !important;
  display: flex;
  align-items: center;
  padding-top: 20px;
  padding-left: 20px;
  padding-right: 20px;
  border-top: 1px solid rgba(0, 0, 0, 0.2);
  width: 100%;
  // background-color: rebeccapurple;
  .economicsTable {
    border: 1px solid rgba(0, 0, 0, 0.2);
    display: flex;
    flex-direction: column;
    padding-left: 20px;
    padding-right: 20px;
    border-radius: 15px;
    padding-bottom: 15px;
    height: auto;
    width: 100%;
    // background-color: rgba(0,9,231,0.4);
    .title {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      height: 30px;
      // background-color: rosybrown;
      .right {
        .close {
          font-size: 14px;
          cursor: pointer;
        }
        .close:hover {
          text-decoration: underline;
        }
      }
      .economicsTable-download:hover {
        cursor: pointer;
        text-decoration: underline;
      }
    }
    .table1 {
      border: 1px solid rgba(0, 0, 0, 0.2);
      height: auto;
      width: 100%;
      // background-color: green;
    }
  }
}
/deep/.el-table__header-wrapper {
  table {
    thead {
      background: #a3e4fe !important;
    }
  }
}
</style>